import { Desc, t } from '@sm/intl';
import { Packages, PackageIds } from '~shared/constants/pricing';
import COPY from '~pricing/lib/packages/copy';
import PACKAGE_COPY from '~pricing/experiments/grow_2792_pnp_refresh_v1/copy/experimentPackageCopy';
import { PackageDef } from '~pricing/lib/packages/types';

export const TogglePackages = [
  Packages.AdvantageMonthly,
  Packages.AdvantageAnnual,
  Packages.TeamAdvantage,
  Packages.FormsAnnual,
  Packages.FormsMonthly,
];

export const PACKAGE_SWAP = {
  [Packages.FormsAnnual]: {
    id: PackageIds.FORMS_ANNUAL,
    swap: {
      packageName: Packages.FormsMonthly,
      id: PackageIds.FORMS_MONTHLY,
    },
  },
  [Packages.FormsMonthly]: {
    id: PackageIds.FORMS_MONTHLY,
    swap: {
      packageName: Packages.FormsAnnual,
      id: PackageIds.FORMS_ANNUAL,
    },
  },
  [Packages.AdvantageAnnual]: {
    id: PackageIds.ADVANTAGE_ANNUAL,
    swap: {
      packageName: Packages.AdvantageMonthly,
      id: PackageIds.ADVANTAGE_MONTHLY,
    },
  },
  [Packages.AdvantageMonthly]: {
    id: PackageIds.ADVANTAGE_MONTHLY,
    swap: {
      packageName: Packages.AdvantageAnnual,
      id: PackageIds.ADVANTAGE_ANNUAL,
    },
  },
};

const PER_USER_PER_MONTH = t(COPY.PER_USER_PER_MONTH);

export const PackageDefs: PackageDef = {
  [Packages.Enterprise]: {
    // todo: update copy
    byline: t(COPY.ENTERPRISE),
  },
  [Packages.AdvantageMonthly]: {
    priceUnit: PER_USER_PER_MONTH,
    highlighted: true,
  },
  [Packages.TeamAdvantage]: {
    priceUnit: t(COPY.PER_MONTH_ANNUALLY),
    highlighted: true,
  },
};

export const PackageDisplayNames: Partial<Record<Packages, Desc>> = {
  [Packages.AdvantageMonthly]: PACKAGE_COPY.ADVANTAGE_MONTHLY,
  [Packages.AdvantageAnnual]: PACKAGE_COPY.ADVANTAGE_ANNUAL,
  [Packages.TeamAdvantage]: PACKAGE_COPY.TEAM_ADVANTAGE,
  [Packages.PremierAnnual]: PACKAGE_COPY.PREMIER_ANNUAL,
  [Packages.TeamPremier]: PACKAGE_COPY.TEAM_PREMIER,
};
